import Debug from 'debug';

import {
    CONSOLE_SEVERITY,
    type DebugLogLabels,
    type DebugLogLevel,
    type DebugStructuredLog,
} from './types';

const debuggers: { [namespace: string]: Debug.Debugger } = {};

/**
 * Write to the console
 */
export function writeToConsole(
    namespace: string,
    level: DebugLogLevel,
    entry: {
        message: string;
        args: any[];
        labels?: DebugLogLabels;
    }
) {
    if (level === 'debug') {
        const debug = debuggers[namespace] || Debug(namespace);
        debuggers[namespace] = debug;

        debug(entry.message, ...entry.args);
        return;
    }

    // biome-ignore lint/suspicious/noConsole: We need to log to the console..!
    console[CONSOLE_SEVERITY[level]](`[${namespace}] ${entry.message}`, ...entry.args);
}

/**
 * Log a structured payload.
 * https://cloud.google.com/logging/docs/structured-logging
 */
export function writeStructuredLog(log: DebugStructuredLog) {
    if (process.env.NODE_ENV === 'development') {
        // biome-ignore lint/suspicious/noConsole: We need to log to the console..!
        console[CONSOLE_SEVERITY[log.level]](`${log.level.toUpperCase()}: ${log.message}`);
    } else if (process.env.NODE_ENV !== 'test') {
        // biome-ignore lint/suspicious/noConsole: We need to log to the console..!
        console[CONSOLE_SEVERITY[log.level]]({
            ...log.payload,
            severity: log.level.toUpperCase(),
            message: log.message,
            ...(log.labels ? { labels: log.labels } : {}),
        });
    }
}
